/**
 *
 * ResultByDimension
 *
 */

import "./index.less"

import { Button, Checkbox, Popover, Spin, Tooltip } from "antd"
import {
  CaretDownOutlined,
  CaretUpOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons"
import React, { Fragment } from "react"
import { find, get, isEqual, truncate } from "lodash"
import { markReadActionPlan, markReadComment } from "../DrawerActionPlan/api"

import Bubbles from "../Bubbles"
import DrawerActionPlan from "../DrawerActionPlan"
import FlechaSVG from "../../images/iconoFlecha.svg"
import ModalActionPlanCreate from "../ModalActionPlanCreate"
import ProgressBar from "../ProgressBar"
import imgCommentTable from "../../images/comment-table.svg"
import imgEllipses from "../../images/ellipses.svg"
import imgMark from "../../images/mark_item.svg"
import imgWarning from "../../images/warning.svg"
import questionIcon from "images/question.svg"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { isModuleBySlug } from "../../utils/storage"
import { ACTION_PLANS } from "../../utils/constants"
import PopoverBenchmark from "../../Reports/components/PopoverBenchmark"
import { validate } from "../../utils/functions"
import MeasurementColorRange from "../MeasurementColorRange"
import { ArrowUpIcon } from "../../icons/svg/iconArrowUp"
import { ArrowDownIcon } from "../../icons/svg/iconArrowDown"

// import PropTypes from 'prop-types';

/* eslint-disable react/prefer-stateless-function */
class ResultByDimension extends React.Component {
  state = {
    modalActionPlanCreate: false,
    drawerActionPlan: false,
    drawerActionPlanOpenIn: "1",
    dimensionSelected: undefined,
    paintRowIndex: undefined,
    columns: [
      {
        name: "Dimensiones",
        order: {
          active: false,
          type: "asc",
          key: "name",
        },
      },
      { name: "Impacto" },
      {
        name: "Resultado",
        order: {
          active: false,
          type: "asc",
          key: "value",
        },
      },
      { name: "1-2" },
      { name: "3" },
      { name: "4-5" },
      { name: "" },
      {
        name: "Medición anterior",
        order: {
          active: false,
          type: "asc",
          key: "name",
        },
      },
      { name: "Benchmark" },
    ],
    sorter: false,
  }

  componentDidMount() {
    this.addColumn()
  }

  componentDidUpdate(nextProps, prevState) {
    if (!isEqual(this.props.showColumnImpact, nextProps.showColumnImpact)) {
      this.addColumn()
    }
  }

  setStateFrom = (values) => {
    this.setState(values)
  }

  renderBubble = (e) => {
    return (
      <div
        className="ResultByDimensionComponent-table-body-row-bubble"
        style={e.impact == 0 ? { gridTemplateColumns: "auto auto auto" } : {}}>
        {e.impact >= 0.5 ? (
          <Tooltip
            placement="right"
            overlayClassName="tooltipWhite"
            title="Alto impacto">
            <img src={imgMark} />
          </Tooltip>
        ) : (
          <div />
        )}

        <span
          style={
            e.impact == 0
              ? { marginLeft: 0, textAlign: "center", color: "#8d8a8d" }
              : {}
          }>
          {e.impact == 0 ? (
            <Tooltip title="El impacto no es significativo.">
              <span style={{ color: "#8D8A8D" }}>-</span>
            </Tooltip>
          ) : (
            e.impact
          )}
        </span>
        {e.impact != 0 ? <Bubbles left={e.impact} right={e.impact} /> : <div />}
      </div>
    )
  }

  renderRow = (e, i, isChild = false) => {
    if (e?.name === "Engagement") return
    const {
      openDimensions,
      bubble,
      showVariation,
      showCheckbox,
      selectedDimension,
      selectedDivision = {},
      showColumnImpact,
      showBenchmark,
    } = this.props
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    const contentWarning = (
      <div className="content-warning-action">
        <p>
          Identificado como <b>oportunidad de mejora.</b>
        </p>
        <Button
          type="primary"
          onClick={() => {
            woopraTrack("Crear plan de acción")
            this.setState({ modalActionPlanCreate: true })
          }}>
          Crear plan de acción
        </Button>
      </div>
    )
    const getMeasureStatus = find(
      this.props.meditions,
      (medition) => medition.id_measure === selectedDivision.id_measure
    ) || { engagement: true }

    const styleTable = this.setStyleTable()

    return (
      <Fragment key={`${i}-2`}>
        <div
          key={i}
          className={`ResultByDimensionComponent-table-body-row ${showColumnImpact &&
            "ResultByDimensionComponent-table-body-row-showColumnImpact"}  ${
            e.is_long
              ? "ResultByDimensionComponent-table-body-rowQuestion"
              : isChild
              ? "ResultByDimensionComponent-table-body-rowChild"
              : ""
          }${
            this.state.paintRowIndex === e.id_dimension && !e.question_name
              ? " pain-row-color"
              : ""
          }`}
          style={styleTable.body}>
          {bubble && this.renderBubble(e)}

          <div
            className={`ResultByDimensionComponent-table-body-row-description ${
              !isChild ? " bold" : ""
            }`}
            style={{ paddingLeft: e.level * (showCheckbox ? 18 : 14) }}>
            {e.level !== 3 &&
              e.is_improvement_opportunity &&
              isActionPlans &&
              !this.props.hideIcons &&
              getMeasureStatus.id_measure_status === 5 && (
                <Popover
                  placement="top"
                  content={contentWarning}
                  onVisibleChange={(visible) => {
                    if (visible) {
                      this.setState({ dimensionSelected: e })
                    } else {
                      this.setState({ dimensionSelected: undefined })
                    }
                  }}>
                  <img
                    className="image-warning"
                    style={bubble ? { left: -20 } : {}}
                    src={imgWarning}
                    alt="warning"
                  />
                </Popover>
              )}

            {showCheckbox && !e.is_long ? (
              <Checkbox
                checked={selectedDimension.includes(e.id_dimension)}
                onChange={() => this.props.onSelectDimension(e.id_dimension)}>
                {e?.name}
              </Checkbox>
            ) : (
              <span
                style={{
                  padding: 0,
                  display: "inline",
                  color: "#4F4F4F",
                  // cursor: [1, 2].includes(e.level) && validRole({ role: [1, 2, 3, 4, 5] }) && this.props.selectedDivision ? 'pointer' : 'default'
                  cursor:
                    [1, 2].includes(e.level) &&
                    this.props.selectedDivision &&
                    getMeasureStatus.id_measure_status === 5
                      ? "pointer"
                      : "default",
                }}
                onClick={() => {
                  // if ([1, 2].includes(e.level) && validRole({ role: [1,2, 3, 4, 5] }) && this.props.selectedDivision) {
                  if (
                    [1, 2].includes(e.level) &&
                    this.props.selectedDivision &&
                    getMeasureStatus.id_measure_status === 5
                  ) {
                    this.setState({
                      drawerActionPlan: true,
                      dimensionSelected: e,
                    })
                  }
                }}
                onMouseEnter={() => {
                  if (e.level === 3) return
                  this.setState({ paintRowIndex: e.id_dimension })
                }}
                onMouseLeave={() => {
                  if (e.level === 3) return
                  this.setState({ paintRowIndex: undefined })
                }}>
                {e?.name}
              </span>
            )}
            {validRole({ role: [1, 2, 3, 4, 5] }) &&
              e.level === 1 &&
              !this.props.hideIcons &&
              e.action_plan &&
              e.comment &&
              getMeasureStatus.id_measure_status === 5 && (
                <div className="actions-ellipses-comment">
                  <div>
                    {!!e.action_plan.count && (
                      <Tooltip
                        placement="top"
                        title={`${e.action_plan.count} ${
                          e.action_plan.count === 1
                            ? "plan de acción nuevo"
                            : "planes de acción nuevos"
                        }`}>
                        <span
                          style={{
                            filter: `grayscale(${Number(
                              !e.action_plan.unread
                            )})`,
                          }}
                          onClick={async () => {
                            if (
                              [1, 2].includes(e.level) &&
                              this.props.selectedDivision
                            ) {
                              this.setState({
                                drawerActionPlan: true,
                                dimensionSelected: e,
                                drawerActionPlanOpenIn: "1",
                              })
                            }

                            await markReadActionPlan({
                              data: {
                                id_measure: e.id_measure,
                                id_division: e.id_division,
                                id_dimension: e.id_dimension,
                              },
                            })

                            if (this.props.getDimensions)
                              this.props.getDimensions(true)
                          }}>
                          {e.action_plan.count}
                          <img src={imgEllipses} alt="img-ellipses" />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    {!!e.comment.count && (
                      <Tooltip
                        placement="top"
                        title={`${e.comment.count} ${
                          e.comment.count === 1
                            ? "nuevo comentario"
                            : "nuevos comentarios"
                        }`}>
                        <span
                          style={{
                            filter: `grayscale(${Number(!e.comment.unread)})`,
                          }}
                          onClick={async () => {
                            if (
                              [1, 2].includes(e.level) &&
                              this.props.selectedDivision
                            ) {
                              this.setState({
                                drawerActionPlan: true,
                                dimensionSelected: e,
                                drawerActionPlanOpenIn: "2",
                              })
                            }
                            await markReadComment({
                              data: {
                                id_measure: e.id_measure,
                                id_division: e.id_division,
                                id_dimension: e.id_dimension,
                              },
                            })

                            if (this.props.getDimensions)
                              this.props.getDimensions(true)
                          }}>
                          {e.comment.count}
                          <img src={imgCommentTable} alt="img-comment-table" />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                </div>
              )}
          </div>
          {showColumnImpact && (
            <div className="ResultByDimensionComponent-table-body-row-description text-center">
              {!e.is_long && this.renderBubble(e)}
            </div>
          )}
          <div className="ResultByDimensionComponent-table-body-row-description">
            <span style={{ backgroundColor: e.color, width: 60 }}>
              {e.value_visible}
            </span>
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_low_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_middle_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description">
            <ProgressBar
              values={{
                low: e.value_low_visible,
                top: e.value_visible,
                middle: e.value_middle_visible,
              }}
              style={{ width: "90%" }}
            />
          </div>
          {showVariation && (
            <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
              {e.variation == 0 ? (
                e.variation === 0 ? (
                  <strong
                    style={{
                      marginRight: 12,
                      color: "#4F4F4F",
                    }}>{`${e.prev_value}%`}</strong>
                ) : (
                  "-"
                )
              ) : e.variation > 0 ? (
                <strong
                  style={{
                    marginRight: 12,
                    color: "#4F4F4F",
                  }}>{`${e.prev_value}%`}</strong>
              ) : (
                <strong
                  style={{
                    marginRight: 12,
                    color: "#4F4F4F",
                  }}>{`${e.prev_value}%`}</strong>
              )}
              {e.variation == 0
                ? e.variation === 0
                  ? "0%"
                  : ""
                : e.variation > 0
                ? `${e.variation}%`
                : `${e.variation}%`.replace(/-(?=\d)/, "")}
              {e.variation != 0 && (
                <div
                  className={`resultByDimension-triangle ${
                    e.variation > 0
                      ? "resultByDimension-triangle--positive"
                      : ""
                  }`}
                />
              )}
            </div>
          )}
          {showBenchmark && (
            <div className="ResultByDimensionComponent-table-body-row-description-benchmark color-gray-low">
              {validate.exist(e.benchmark) && (
                <Fragment>
                  {e.benchmark.show ? (
                    <strong
                      style={{
                        marginRight: 12,
                        color: "#4F4F4F",
                      }}>{`${e.benchmark.value}`}</strong>
                  ) : (
                    <Popover
                      placement="top"
                      overlayClassName="popoverNotDataBenchmark"
                      content={
                        <div>
                          No se cuenta con data para el benchmark de la
                          dimensión.
                        </div>
                      }>
                      <span className="emptyValueVisibleBenchmark">-</span>
                    </Popover>
                  )}
                  {e.benchmark.show
                    ? `${e.benchmark.variation}%`.replace(/-(?=\d)/, "")
                    : null}
                  {e.benchmark.show ? (
                    e.benchmark.level ? (
                      <ArrowUpIcon />
                    ) : e.benchmark.level === false ? (
                      <ArrowDownIcon />
                    ) : null
                  ) : null}
                </Fragment>
              )}
            </div>
          )}
          <div className="ResultByDimensionComponent-table-body-row-description text-center">
            {e.childs && e.childs.length > 0 ? (
              openDimensions.includes(e.id_dimension) ? (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(-90deg)" }}
                />
              ) : (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                />
              )
            ) : null}
          </div>
        </div>

        {e.childs &&
          openDimensions.includes(e.id_dimension) &&
          e.childs.map((c, i) => this.renderRow(c, i, true))}
      </Fragment>
    )
  }

  renderIconQuestions = () => {
    const { measureColorRange } = this.props
    return <MeasurementColorRange measureColorRange={measureColorRange} />
  }

  /* eslint-disable */
  compareValues = (key, order = "asc") => {
    key = key === "value_visible" ? "value" : key
    return (a, b) => {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0
      }

      let varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key]
      let varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key]
      if (
        Number.isInteger(parseInt(varA)) &&
        Number.isInteger(parseInt(varB))
      ) {
        varA = parseInt(varA)
        varB = parseInt(varB)
      }

      let comparison = 0
      if (varA > varB) {
        comparison = 1
      } else if (varA < varB) {
        comparison = -1
      }
      return order == "desc" ? comparison * -1 : comparison
    }
  }
  /* eslint-enable */

  sortColumn = (key, type) => {
    const { columns } = this.state
    columns.map((e) => {
      if (e.order) e.order.active = false
    })
    columns[key].order.type = type
    columns[key].order.active = true
    let items = this.props.data
    items = items.sort(this.compareValues(columns[key].order.key, type))
    this.setState({
      columns,
      sorter: columns[key].order.type,
    })
  }

  addColumn = () => {
    const { showColumnImpact } = this.props
    const { columns } = this.state

    let setColumns = []
    if (!showColumnImpact) {
      setColumns = [...columns, { name: "", showIcon: true }]
    } else {
      setColumns = columns.filter((item) => !item.showIcon)
    }
    this.setState({ columns: setColumns })
  }

  setTitleColumn = (item) => {
    const { showColumnImpact, metricsTotalLabel } = this.props

    let response
    if (!showColumnImpact) {
      response = !item.showIcon ? item?.name : this.renderIconQuestions()
      response
    } else {
      response = item?.name ? item?.name : this.renderIconQuestions()
    }

    if (response === "Resultado") {
      return (
        <Tooltip placement="top" title={metricsTotalLabel}>
          {truncate(metricsTotalLabel, {
            length: 16,
            separator: /,? +/,
          })}
        </Tooltip>
      )
    }

    return response
  }

  setStyleTable = () => {
    const { bubble, showVariation, showBenchmark } = this.props
    const widthImpact = "140px"
    const widthResult = "124px"
    const width1or2 = "40px"
    const width3 = "40px"
    const width4or5 = "40px"
    const widthProgress = "120px"
    const widthPreviousMeasurement = "170px"
    const widthBenchmark = "170px"
    const widthDropDown = "80px"
    if (bubble && showVariation && showBenchmark) {
      return {
        header: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement} ${widthBenchmark} ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthBenchmark} ${widthDropDown}`,
        },
      }
    }
    if (bubble && showVariation) {
      return {
        header: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthDropDown}`,
        },
      }
    }
    if (bubble && showBenchmark) {
      return {
        header: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthBenchmark} ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthBenchmark} ${widthDropDown}`,
        },
      }
    }
    if (showVariation && showBenchmark) {
      return {
        header: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthBenchmark} ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthBenchmark} ${widthDropDown}`,
        },
      }
    }
    if (bubble) {
      return {
        header: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `${widthImpact} 1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthDropDown}`,
        },
      }
    }
    if (showVariation) {
      return {
        header: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthPreviousMeasurement}  ${widthDropDown}`,
        },
      }
    }
    if (showBenchmark) {
      return {
        header: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthBenchmark} ${widthDropDown}`,
        },
        body: {
          gridTemplateColumns: `1.5fr ${widthResult} ${width1or2} ${width3} ${width4or5} ${widthProgress} ${widthBenchmark} ${widthDropDown}`,
        },
      }
    }
    return { header: {}, body: {} }
  }

  render() {
    const {
      data,
      divisions,
      isLoading,
      bubble,
      showVariation,
      hideHeaders,
      showColumnImpact,
      selectedDivision = {},
      showBenchmark,
    } = this.props
    const { columns, sorter, dimensionSelected } = this.state
    const getMeasureStatus = find(
      this.props.meditions,
      (medition) => medition.id_measure === selectedDivision.id_measure
    ) || { engagement: true }

    const tooltip = (
      <Popover
        placement="leftTop"
        title="Impacto"
        content={
          <div
            style={{
              maxWidth: 400,
              textAlign: "justify",
              margin: "15px auto",
            }}>
            El análisis de <b>Impacto</b> identifica, a través de un modelo
            estadístico de correlación, cuáles son las dimensiones que tienen un
            mayor impacto en el <b>Engagement</b> de la organización. De esta
            manera, la organización podrá crear planes de acción direccionados a
            aquellas dimensiones que tienen una mayor probabilidad de afectar
            directamente el resultado de <b>Engagement</b>.<br />
            Para facilitar su rápida identificación, las dimensiones con un alto
            impacto se encuentran marcadas con un ícono (
            <img src={imgMark} height="13" />
            ).
          </div>
        }>
        <QuestionCircleFilled
          style={{
            color: "#D8D8D8",
            verticalAlign: "baseline",
            fontSize: "14px",
          }}
        />
      </Popover>
    )

    const contentVariation = (
      <div className="content-variation">
        <p>
          La <span>variación</span> hace referencia a la diferencia porcentual
          entre el resultado del indicador en la medición anterior versus la
          medición actual.
        </p>
        <div>
          <div className="content-variation__triangle content-variation__triangle--positive" />
          Variación positiva (incremento)
        </div>
        <div>
          <div className="content-variation__triangle" />
          Variación negativa (disminución)
        </div>
      </div>
    )
    const styleTable = this.setStyleTable()
    return (
      <div className="ResultByDimensionComponent">
        <div className="ResultByDimensionComponent-table">
          <div className="ResultByDimensionComponent-table-body ResultByDimensionComponent-table-body-header">
            <div
              className={`ResultByDimensionComponent-table-body-row ${showColumnImpact &&
                "ResultByDimensionComponent-table-body-row-showColumnImpact"}`}
              style={styleTable.header}>
              {bubble && (
                <div className="ResultByDimensionComponent-table-body-row-title text-center">
                  Impacto {tooltip}{" "}
                </div>
              )}
              {columns.map((item, i) => {
                if (!showVariation && item?.name === "Medición anterior") return
                if (!showColumnImpact && item?.name === "Impacto") return
                if (!showBenchmark && item?.name === "Benchmark") return

                return (
                  <div
                    key={i}
                    className={`ResultByDimensionComponent-table-body-row-title ${
                      item?.name === "Medición anterior" ||
                      item?.name === "Impacto" ||
                      item?.name === "Benchmark"
                        ? ""
                        : ""
                    }`}>
                    {!hideHeaders.includes(i) && this.setTitleColumn(item)}
                    {item?.name === "Medición anterior" && (
                      <Popover
                        placement="bottomRight"
                        content={contentVariation}>
                        <img
                          src={questionIcon}
                          alt="question"
                          style={{ marginLeft: 4, cursor: "pointer" }}
                        />
                      </Popover>
                    )}
                    {item?.name === "Benchmark" && (
                      <PopoverBenchmark
                        container={
                          <img
                            src={questionIcon}
                            alt="question"
                            style={{ marginLeft: 4, cursor: "pointer" }}
                          />
                        }
                        isGlobalBenchmark={
                          this.props.measureGeneral.is_global_benchmark
                        }
                      />
                    )}
                    {hideHeaders.includes(i) || !item.order ? null : (
                      <div
                        className="reorderColumn"
                        onClick={() =>
                          this.sortColumn(i, sorter == "asc" ? "desc" : "asc")
                        }>
                        <CaretUpOutlined
                          className={`reorderColumn-up ${
                            item.order.active && item.order.type === "asc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                        <CaretDownOutlined
                          className={`reorderColumn-down ${
                            item.order.active && item.order.type === "desc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          {isLoading ? (
            <div className="ResultByDimensionComponent-table-body-loading">
              <Spin size="large" />
            </div>
          ) : (
            <div className="ResultByDimensionComponent-table-body">
              {data && data.map((e, i) => this.renderRow(e, i))}
              {!this.props.hideMessageLess25 &&
                showColumnImpact &&
                get(data, "[0].showImpact", false) &&
                getMeasureStatus.engagement && (
                  <div
                    className={`result-dimensions-less25 ${
                      data && data.length >= 12 ? "rotate" : ""
                    }`}>
                    <div>
                      <span>
                        Se requiere de un mínimo de 25 respuestas para poder
                        calcular el impacto.
                      </span>
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
        <ModalActionPlanCreate
          visible={this.state.modalActionPlanCreate}
          onCancel={() => this.setState({ modalActionPlanCreate: false })}
          finish={() => this.props.getDimensions(true)}
          initialData={{
            measure: dimensionSelected && dimensionSelected.id_measure,
            division: {
              id_division: dimensionSelected && dimensionSelected.id_division,
              division_name:
                dimensionSelected &&
                find(
                  divisions,
                  (item) => item.id_division === dimensionSelected.id_division
                )?.name,
            },
            dimensions: [dimensionSelected && dimensionSelected.id_dimension],
          }}
        />

        {this.state.drawerActionPlan && (
          <DrawerActionPlan
            getDimensions={this.props.getDimensions}
            visible={this.state.drawerActionPlan}
            drawerActionPlanOpenIn={this.state.drawerActionPlanOpenIn}
            initialData={dimensionSelected}
            setStateFrom={this.setStateFrom}
            divisions={divisions}
          />
        )}
      </div>
    )
  }
}

ResultByDimension.propTypes = {}
ResultByDimension.defaultProps = {
  hideHeaders: [],
  onSelectDimension: () => {},
  selectedDimension: [],
  showColumnImpact: false, // mostrar columna impacto
  showBenchmark: false,
}
export default ResultByDimension
